import React from "react";
import "./vikas.css";

const VikasKame = () => {
  const works = [
    // --- Existing development works ---
    {
      title: "✅ खाजगी विहिरी",
      desc:

        "* तुकडोजी मंदिर\n" +
        "* मनोहर नरुळे\n" +
        "* डोमा भांडारकर\n" +
        "* हरी धुबडे\n" +
        "* निरंजन निरूले\n" +
        "* बंडू बाळे \n" +
        "* पत्रु निवाडे\n" +
        "* हरबा लोंडे\n" +
        "* दादाजी बनबळे\n" +
        "* सखाराम चौधरी\n" +
        "* बांगणीं विहीर\n" +
        "* शिला राऊत\n",
      year: "नियमित सेवा",

    },
    {
      title: "✅ खाजगी विहिरी",
      desc:

        "* भास्कर बनबळे\n" +
        "* दिवाकर नरुले\n" +
        "* योगराज चौधरी\n" +
        "* ज्ञानेश्वर चौधरी\n" +
        "* संजय लोणारे\n" +
        "* दिवाकर कास्मिरे \n" +
        "* रामदाश तिवाडे\n" +
        "* अनिता दिवरे\n" +
        "* शुधाकर भोयर\n" +
        "* बाळू नरुले\n" +
        "* तुकाराम राऊत\n" +
        "* तुकाराम राऊत\n" +
        "* पुरुषोत्तम खेवले\n" + 
        "* निर्मला निशाने\n" +
         "* काशीनाथ पैदरकर\n" +


        "* भाऊराव दुमाने\n",
      year: "नियमित सेवा",

    },

    {
      title: "✅ सरकारी हातपंप ",
      desc:
        
        "१) बसस्टॉप हँडपंप \n" +
        "२) मनोहर तिवाडे \n" +
        "३) प्राथमिक आरोग्य केंद्र \n" +
        "४) विस्वनाथ शेंडे  \n" +
        "५) कठू दमाने  \n" +
        "६) राशीक रामटके  \n" +
        "७) बौद्ध विहार टोली \n" +
        "८) शालीकराम गावतुरे   \n" +
        "९) यशवंत राजगडे \n" +
        "१०) महादेव मंदिर आ. क्रम.१ \n" +
        "११ ) प्रभाकर ढुबडे \n" +
        "१२ ) आंगणवडी क्रम.-५ \n" +
        "१३ ) ज्ञानेश्वर चौधरी   \n" +
        "१४ ) ऋषी  वाढणकर \n" +
        "१५ ) माधव  खोये \n" +
        "१६ ) नीलेश सलोटे \n" +
        "१७ ) रामभाऊ अष्टेकर \n" +
        "१८ ) नितीन मस्के \n" +
        "१९ ) सुरेश गिरडकर \n" +
        "२० ) ईश्वर खोकले \n" +
        "२१ ) बिरसा मुंडा \n" +
        "२२ ) कवडू उरकुडे \n" +
        "२३ ) भगवान  पोटे \n" +
        "२४ ) विनोद  ठाकरे \n" +
        "२५ ) आंगराज चौधरी \n" ,
      year: "नियमित सेवा",
    },

    {
      title: "🏛️ ग्रामपंचायत मालमत्ता व सुविधा",
      desc:
        "१) ग्रामपंचायत कार्यालय\n" +
        "२) ग्रामपंचायत सभागृह\n" +
        "३) सार्वजनिक स्वच्छतागृह (पुरुष / महिला)\n" +
        "४) घनकचरा व्यवस्थापन सुविधा\n" +
        "५) दुकान गाळे (भाडे तत्त्वावर)\n" +
        "६) पाणीपुरवठा टाक्या व नळजोडणी\n" +
        "७) इतर ग्रामपंचायत उपक्रम व साधने\n",
      year: "नियमित सेवा",
    },
    {
      title: "🌊 तलाव खोलीकरण व जलसंधारण माहिती",
      desc:
        "१) कांबळी तलाव – क्षेत्रफळ : 776 | खोली : 1.12 मी\n" +
        "२) आमई तलाव – क्षेत्रफळ : 800 | खोली : 4.85 मी\n" +
        "३) गाव तलाव – क्षेत्रफळ : 766 | खोली : 12.45 मी\n" +
        "४) सरकारी तलाव – क्षेत्रफळ : 928 | खोली : 1.37 मी\n" +
        "५) स्मशानभूमी तलाव – क्षेत्रफळ : 741 | खोली : 1.44 मी\n",
      year: "जलसंधारण अंतर्गत",
    },

    {
      title: "🚽 घरगुती खाजगी बोरवेल (लाभार्थी)",
      desc:
        "१) प्रीतम बाबनवडे\n" +
        "२) खेमराव बाणबळे\n" +
        "३) ज्ञानेश्वर देशमुख\n" +
        "४) जगन उरकुडे\n" +
        "५) संजय ठाकरे (मील)\n" +
        "६) कृष्णा जी किरमिरे \n" +
        "७) दयाराम चीलकले  \n" +
        "८) दयाराम खेवले \n" +
        "९) दादाजी बावणे \n" +
        "१०) नानकसिंग भुराणी   \n" +
        "११) श्रीकांत चौधरी \n" +
        "१२) डॉ. बाछाड   \n" +
        "१३) देवराव भैसारे  \n",
      year: "स्वच्छ भारत अभियान",
    },

    {
      title: "✅ पाणीपुरवठा योजना सुधारणा",
      desc: "गावातील पाण्याची समस्या सोडवण्यासाठी नवीन नळ लाईन आणि टाकी दुरुस्तीचे काम पूर्ण.",
      year: "2024-25",
    },

    {
      title: "✅ ग्रामपंचायत इमारत देखभाल",
      desc: "ग्रामपंचायत कार्यालयाचे नूतनीकरण, रंगकाम, वीजयोजना अपग्रेडेशन.",
      year: "2024",
    },
    {
      title: "✅ LED स्ट्रीट लाइट बसविणे",
      desc: "पर्यावरणपूरक LED लाईट्स बसवून ऊर्जा बचत वाढवली.",
      year: "2023",
    },
    {
      title: "✅ जलसंधारण कामे",
      desc: "पाणी आडवा-पाणी जिरवा अंतर्गत बंधारे, नालेसफाई, गाळकाढणीची कामे.",
      year: "2022-23",
    },
    {
      title: "✅ स्वच्छता अभियान",
      desc: "स्वच्छ भारत मिशन अंतर्गत सार्वजनिक ठिकाणांची स्वच्छता व जागरूकता मोहीम.",
      year: "2024",
    },

    // --- Started & Completed Work Sections ---
    {
      title: "🔧 सुरू असलेली विकासकामे",
      desc:
        "१) नाली बांधकाम\n" +
        "२) नाली सफाई\n" +
        "३) पेव्हर ब्लॉक (ग्रा.पं.भवन, हनुमान मंदिर परिसर)",
      year: "2024-25",
    },
    {
      title: "🏁 पूर्ण झालेली विकासकामे",
      desc:
        "१) स्मशानभूमी सिमेंट रोड\n" +
        "२) ढेपे ले-आऊट सिमेंट रोड",
      year: "2023-24",
    },

    // --- Annual Plan ---
    {
      title: "📘 वार्षिक विकास आराखडा",
      desc: "ग्रामपंचायत वार्षिक विकास आराखडा सार्वजनिक नियोजनानुसार राबविण्यात येत आहे.",
      year: "2024-25",
    },

    // --- Citizen Services ---
    {
      title: "👥 नागरिक सेवा",
      desc:
        "* जन्म नोंद दाखला\n" +
        "* मृत्यू नोंद दाखला\n" +
        "* विवाह नोंद दाखला\n" +
        "* प्रतिज्ञापत्र (Affidavit)\n" +
        "* उत्पन्न प्रमाणपत्र\n" +
        "* नॉन-क्रिमिलेअर प्रमाणपत्र\n" +
        "* जात प्रमाणपत्र\n" +
        "* जन्म/मृत्यू प्रमाणपत्र",
      year: "नियमित सेवा",
    },

    // --- Population and Facilities ---
    {
      title: "🏡 गावातील मूलभूत सुविधा",
      desc:
        "लोकसंख्या: १३४५\n" +
        "शाळा: ०२\n" +
        "आरोग्य केंद्र: ०\n" +
        "अंगणवाडी: ०२\n" +
        "सार्वजनिक सुविधा: ०१",
      year: "2024",
    },

    // --- Other information ---
    {
      title: "ℹ️ इतर महत्वाची माहिती",
      desc:
        "• पूर्ण गावाला आरो पाणी मोफत उपलब्ध केले\n" +
        "• पाच लाखांचे माता मंदिर बांधकाम\n" +
        "• तलाव खोलीकरण व तलाव सफाई\n",
      year: "2024",
    },

    // --- Address ---
    {
      title: "📍 कार्यालयाचा पत्ता",
      desc:
        "मु. ग्रामपंचायत  आवळगांव, तह.ब्रम्हपुरी, जिल्हा वर्धा\nईमेल: gpawalagaon3403@gmail.com",
      year: "",
    },

    // --- Schemes Section (New Added as per your request) ---
    {
      title: "🎯 विविध शासकीय योजना",
      desc:
        "१) मुख्यमंत्री लाडकी बहिण योजना\n" +
        "२) प्रधानमंत्री आवास योजना\n" +
        "३) आयुष्मान भारत कार्ड योजना\n" +
        "४) वयोश्री योजना\n" +
        "५) श्रम कार्ड योजना\n" +
        "६) निराधार योजना\n" +
        "७) संजय गांधी योजना\n" +
        "८) लेक लाडकी योजना\n" +
        "९) प्रधानमंत्री विश्वकर्मा योजना\n" +
        "१०) दिव्यांग निधी लाभ योजना",
      year: "चालू वर्ष",
    },
  ];

  return (
    <div className="vikas-container">
      <h2 className="vikas-title">🏗 विकास कामे (Development Works)</h2>

      <div className="vikas-grid">
        {works.map((work, index) => (
          <div className="vikas-card" key={index}>
            <h3 className="work-title">{work.title}</h3>
            <p className="work-desc" style={{ whiteSpace: "pre-line" }}>
              {work.desc}
            </p>
            {work.year && <p className="work-year">📅 वर्ष : {work.year}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VikasKame;
